/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyBillPayment from './pharmacy-bill-payment';
import PharmacyBillPaymentDetail from './pharmacy-bill-payment-detail';
import PharmacyBillPaymentUpdate from './pharmacy-bill-payment-update';
import PharmacyBillPaymentDeleteDialog from './pharmacy-bill-payment-delete-dialog';

const PharmacyBillPaymentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyBillPayment />} />
    <Route path="new" element={<PharmacyBillPaymentUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyBillPaymentDetail />} />
      <Route path="edit" element={<PharmacyBillPaymentUpdate />} />
      <Route path="delete" element={<PharmacyBillPaymentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyBillPaymentRoutes;
